/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useMutation } from '@apollo/client';
import { useTokenContext } from "@exo/frontend-common-app-identity-and-access";


const OPT_IN_MUTATION = gql`
mutation OptIn($optInRequest: OptInRequest!) {
optIn(optInRequest: $optInRequest) {
  optInTimedOutError
}
}
`;

export const useOptInRequest = () => {
  const tokenContext = useTokenContext();
  const [optInMutation] = useMutation(OPT_IN_MUTATION);

  return {
    optIn: async (optInRequest) => {
      await tokenContext.ensureValidToken();
      const response = await optInMutation({ variables: { optInRequest } });

      return response;
    },
    optInForLoginUser: async (optInRequest) => {
      const response = await optInMutation({ variables: { optInRequest } });

      return response;
    }
  }
}

